/*import { LibroAdminListBean } from 'LibroAdminBean';*/
import { LibroAdminListBean } from './libroAdminBean';


export class LibroAdminListResponse{
    httpStatus: String;
    response: {
        id: String,
        codeResponse: String,
        response: String,
        list: Array<LibroAdminListBean>
    }

    constructor(){
        this.httpStatus="0";
        this.response={
            id:"",
            codeResponse:"",
            response:"",
            list:[]
        }
      }
      
}